module.exports = __webpack_public_path__ + "img/newspapers_button_small_down.0e9f10a2.png";